/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_FinalizingInputs */



/**
* | output |
* | --- |
* | "Publishing complete. Finalizing publish workflow..." |
*
* @param {Work_Order_Publish_Status_FinalizingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_finalizing = /** @type {((inputs?: Work_Order_Publish_Status_FinalizingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_FinalizingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publication terminée. Finalisation du flux de publication...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichung abgeschlossen. Veröffentlichungsprozess wird finalisiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione completata. Finalizzazione del flusso di lavoro di pubblicazione in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Публикация завершена. Завершается настройка процесса публикации...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicación completada. Finalizando el flujo de trabajo de publicación...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布完成。正在完成发布工作流程……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開が完了しました。公開ワークフローを最終処理しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन प्रक्रिया पूरी हो गई है। प्रकाशन कार्यप्रवाह को अंतिम रूप दिया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicação concluída. Finalizando o fluxo de trabalho de publicação...")
	return /** @type {LocalizedString} */ ("Publishing complete. Finalizing publish workflow...")
});